<script>
  export let size = 42;
</script>

<svg width={size} height={size} viewBox="0 0 34 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_38_5351)">
    <path
      d="M12.4604 43.0246C12.4604 43.0246 8.61584 44.5532 4.22104 42.1794L6.22657 38.3578C6.22657 38.3578 12.3663 40.298 15.1175 37.9463L12.4532 43.0172L12.4604 43.0246Z"
      fill="#FF849F"
    />
    <path
      d="M0.159284 25.2029C0.159284 25.2029 -1.61456 29.7814 6.82027 34.3452C6.82027 34.3452 13.5392 38.2476 12.4676 43.0246L15.132 37.9537C16.2325 35.8591 15.733 33.2722 13.9302 31.751C12.9672 30.9426 11.6857 30.0754 9.98424 29.2596C8.33348 28.4732 6.79131 27.4443 5.50256 26.1362C3.95315 24.5561 2.49787 22.3734 2.91056 19.9629L0.159284 25.2029Z"
      fill="#FC476F"
    />
    <path
      d="M30.4523 30.8175C30.4523 30.8175 26.9915 34.3892 10.6793 25.7981C9.63671 25.2469 8.55792 24.7912 7.42121 24.4826C5.26363 23.8946 2.0345 23.439 0.159286 25.2028L2.91057 19.9628C3.98212 17.9198 6.30622 16.9129 8.50724 17.5229C9.97701 17.9271 11.7364 18.5665 13.5899 19.566C13.5899 19.566 29.0043 29.2375 32.885 22.5203L30.4523 30.8175Z"
      fill="#FF849F"
    />
    <path
      d="M19.5052 0.51709C19.5052 0.51709 28.7727 8.16758 32.9358 16.7367C34.42 19.794 34.3476 23.3951 32.7692 26.4082L30.4524 30.8177C30.4524 30.8177 32.5448 17.3761 16.1313 6.95496L19.5052 0.51709Z"
      fill="#FC476F"
    />
  </g>
  <defs>
    <clipPath id="clip0_38_5351">
      <rect width="34" height="43" fill="white" transform="matrix(-1 0 0 1 34 0.51709)" />
    </clipPath>
  </defs>
</svg>
